export default __webpack_public_path__ + "static/media/1.b6548a09.gif";